/* @flow */

import swal from './swal';

const toast = swal.mixin({
    timer: 4000,
    position: 'bottom',
    toast: true,
    showConfirmButton: false,
});

export const toastSuccess = toast.mixin({ type: 'success' });

export const toastInfo = toast.mixin({ type: 'info' });

export const toastError = toast.mixin({ type: 'error' });
